<template>
  <div class="cantainer container_upload">
    <div class="top w1380">
      <div class="upload_top" v-if="!uploadFlag" v-loading="loading">
        <div class="upload_bg"></div>
        <el-upload class="upload-demo" drag :action="globalUrl.uploadFile" accept=".pdf" :before-upload="handleBeforeUpload" :file-list="fileList" multiple :on-success="analysis_art">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip" style="font-size: 16px"><i class="el-icon-warning"></i>请上传pdf论文</div>
        </el-upload>
      </div>
      <section class="wapper">
        <div class="importation_function_operation" v-if="importation_function_operation || importation_function_operation_loading" v-loading="importation_function_operation_loading">
          <h2 class="pre-line">论文分析</h2>
          <ul class="tabInfo">
            <li @click="handleTab(1)" :class="{ checked: tabIndex == 1 }">要点</li>
            <li @click="handleTab(2)" :class="{ checked: tabIndex == 2 }">方法</li>
            <li @click="handleTab(3)" :class="{ checked: tabIndex == 3 }">实现过程</li>
          </ul>
          <ul class="improtation_list">
            <li v-for="(item, index) in tabArray" :key="index">{{ item }}</li>
          </ul>
        </div>

        <div class="abstract_info" v-if="abstract">
          <h2 class="pre-line bg">Abstract</h2>
          <div class="abstract_info_div">
            <div class="pre-line overflow_hidden m30">{{ abstract }}</div>
            <div v-if="abstract_translate">
              <h2 class="pre-line m20">翻译</h2>
              <div class="pre-line overflow_hidden">{{ abstract_translate }}</div>
            </div>
          </div>
        </div>

        <div class="introduction_info" v-if="introduction" v-loading="introduction_summarize_loading">
          <h2 class="pre-line bg">Introduction</h2>

          <div class="introduction_info_div">
            <div class="pre-line overflow_hidden m30">{{ introduction }}</div>
            <div v-if="introduction_summarize">
              <h2 class="pre-line m20">总结</h2>
              <div class="pre-line overflow_hidden line30">{{ introduction_summarize }}</div>
            </div>
          </div>
        </div>
        <div v-if="postBody" class="d3-wapper" v-loading="knowLoading">
          <KnowledgeGraph ref="kg_son" :key="countKey" @extendKnowledgeGraph="extendKnowledgeGraph"> </KnowledgeGraph>
          <p class="showMsg" v-if="showMsg">{{ showMsg }}</p>
          <!-- <D4 :parentBody="postBody" /> -->
        </div>
      </section>
    </div>
  </div>
</template>

<script>
// import Upload from '../component/upload'
/* eslint-disable no-unused-vars */
import KnowledgeGraph from "../../components/KnowledgeGraph.vue";
// import D4 from "../components/D4";
export default {
  //   name: 'Home',

  // components: {Upload},
  components: {
    KnowledgeGraph,
  },
  data() {
    return {
      //   activeIndex: 'qikandaohang',
      //   excel_path: '',
      importation_function_operation: null,
      abstract: null,
      abstract_translate: null,
      introduction: null,
      introduction_summarize: null,

      importation_function_operation_loading: false,
      abstract_loading: false,
      introduction_loading: false,
      abstract_translate_loading: false,
      introduction_summarize_loading: false,
      tabList: [],
      tabIndex: 1,
      tabArray: [],
      fileName: "",
      postBody: null,
      uploadFlag: false,
      loading: false,
      fileList: [],
      countKey: 0,
      openAlexId: "",
      uploadType: false, //false 是有pdf  true上传pdf
      showMsg: "",
      knowLoading: false,
    };
  },

  mounted() {
    this.openAlexId = this.$route.query.openAlexId;
    this.getFile();
  },
  methods: {
    getFile() {
      this.loading = true;
      this.$http({
        url: `api/v1/resource/art-analysis/getPdfName?openAlexId=${this.openAlexId}`,
        method: "get",
      }).then(res => {
        if (res.code == 200) {
          this.loading = false;
          if (res.data) {
            // 有pdf
            this.countKey += 1;
            this.uploadType = false;
            this.fileName = res.data;
            this.getData();
          }
        }
      });
    },
    // 加载知识图谱
    initKnowledgeGrapg() {
      // // 尺寸
      // let kg_size = [window.innerWidth-100, window.innerHeight - 50]
      // // 数据
      // let kg_base_data = this.get_kg_base_data()
      // // 调用子组件方法
      // this.$refs.kg_son.initKnowledgeGrapg(kg_size, kg_base_data)

      // 尺寸
      let kg_size = [1380, 800];
      // 数据

      this.$http({
        url: `api/v1/resource/knowledge-graph/text2KnowledgeGraph`,
        method: "post",
        data: this.postBody,
      }).then(res => {
        if (res.code == 1) {
          if (res.data) {
            this.showMsg = "";
            this.knowLoading = false;
            let kg_base_data = res.data;
            // 调用子组件方法
            this.$refs.kg_son.initKnowledgeGrapg(kg_size, kg_base_data);
          } else {
            this.showMsg = res.msg;
            this.knowLoading = true;
          }
        }
      });
    },

    // 展开知识图谱
    extendKnowledgeGraph(cur_node_id) {
      let formData = new FormData();
      formData.append("artRuId", !this.uploadType ? this.openAlexId : this.fileName);
      formData.append("graphId", cur_node_id);
      formData.append("type", this.uploadType ? "upload" : "jump");

      this.$http({
        url: `api/v1/resource/knowledge-graph/knowledgeGraphSpread`,
        method: "post",
        data: formData,
      }).then(res => {
        if (res.code == 1) {
          let kg_extend_data = res.data;
          // 调用子组件方法
          this.$refs.kg_son.extendKnowledgeGraph(cur_node_id, kg_extend_data);
        }
      });
      // 数据
      // this.$axios
      //   .get("http://192.168.0.14:8015/knowledgegraph_extend", {
      //     params: {
      //       art_ruid: "abc1234",
      //       graph_id: cur_node_id,
      //     },
      //   })
      //   .then(res => {
      //     let kg_extend_data = res.data.data;
      //     console.log(kg_extend_data);
      //     // 调用子组件方法
      //     this.$refs.kg_son.extendKnowledgeGraph(cur_node_id, kg_extend_data);
      //   });
    },
    upload_shang() {
      this.$http.post(this.globalUrl.uploadFile, { filename: "" }).then(res => {});
    },
    handleTab(index) {
      this.tabIndex = index;
      if (this.tabIndex == 1) {
        this.tabArray = this.importation_function_operation["要点"];
      }
      if (this.tabIndex == 2) {
        this.tabArray = this.importation_function_operation["方法"];
      }
      if (this.tabIndex == 3) {
        this.tabArray = this.importation_function_operation["实现过程"];
      }
    },
    getRandomTimestamp() {
      const randomDate = new Date(Math.random() * Date.now());
      return randomDate.getTime();
    },
    handleBeforeUpload(file) {
      this.fileList = [file]; // 更新文件列表
    },
    // 上传成功时调用此接口
    analysis_art(response, file, fileList) {
      this.fileName = file.name;
      this.countKey += 1;
      this.tabIndex = 1;
      this.uploadType = true;
      this.getData();
    },
    getData() {
      if (!this.uploadType) {
        this.uploadFlag = true;
      }
      this.importation_function_operation = null;
      this.abstract = null;
      this.abstract_translate = null;
      this.introduction = null;
      this.introduction_summarize = null;

      this.importation_function_operation_loading = true;
      this.abstract_loading = true;
      this.introduction_loading = true;
      this.abstract_translate_loading = true;
      this.introduction_summarize_loading = true;

      // 获取文章摘要
      this.$http.post(this.globalUrl.get_abstract, { filename: this.fileName }).then(res => {
        this.abstract = res.data.abstract;
        this.abstract_loading = false;
        if (this.abstract != null) {
          // 获取摘要翻译
          this.$http
            .post(this.globalUrl.abstract_translate, {
              type: this.uploadType ? "upload" : "jump", //jump
              artRuid: !this.uploadType ? this.openAlexId : this.fileName, //有pdf  this.openAlexId   否  filename
              artText: this.abstract,
            })
            .then(res => {
              this.abstract_translate = res.data.translate;
              this.abstract_translate_loading = false;
            });
        } else {
          this.abstract_translate_loading = false;
        }
      });

      // 获取文章简介
      this.$http.post(this.globalUrl.get_introduction, { filename: this.fileName }).then(res => {
        this.introduction = res.data.introduction;
        // let postBody2 = {
        //   type: val == 1 ? "jump" : "upload", //jump
        //   artRuId: val == 1 ? this.openAlexId : this.fileName, //有pdf  this.openAlexId   否  filename
        //   artText: this.introduction,
        // };
        // 获取简介总结
        if (this.introduction != null) {
          this.$http
            .post(this.globalUrl.introduction_summarize, {
              type: this.uploadType ? "upload" : "jump", //jump
              artRuid: !this.uploadType ? this.openAlexId : this.fileName, //有pdf  this.openAlexId   否  filename
              artText: this.introduction,
            })
            .then(res => {
              this.introduction_summarize = res.data.introduction;
              this.introduction_summarize_loading = false;
            });
        } else {
          this.introduction_summarize_loading = false;
        }
      });

      // 获取文章全文（最大2W字）
      this.$http.post(this.globalUrl.get_content_max20000, { filename: this.fileName }).then(res => {
        let content = res.data.content;
        let timer = new Date(Math.random() * Date.now()).getTime();

        this.postBody = {
          type: this.uploadType ? "upload" : "jump", //jump
          artRuId: !this.uploadType ? this.openAlexId : this.fileName, //有pdf  this.openAlexId   否  filename
          artText: content,
        };
        // 绘制知识图谱
        this.initKnowledgeGrapg();
        // this.getExcelData(content);
        if (content != null) {
          // 获取文章要点、方法、实现过程
          this.$http
            .post(this.globalUrl.get_importation_function_operation, {
              type: this.uploadType ? "upload" : "jump", //jump
              artRuid: !this.uploadType ? this.openAlexId : this.fileName, //有pdf  this.openAlexId   否  filename
              artText: content,
            })
            .then(res => {
              this.importation_function_operation = res.data.importation_function_operation;
              this.tabArray = this.importation_function_operation["要点"];
              this.importation_function_operation_loading = false;
            });
        } else {
          this.introduction_summarize_loading = false;
        }
      });
    },
    // getExcelData(content) {
    //
    //   console.log(timer);
    //   this.$http.post("/api/v1/resource/knowledge-graph/text2KnowledgeGraph", { artRuId: timer, filename: this.fileName, artText: content }).then(res => {});
    // },
  },
};
</script>

<style>
.container_upload .top {
  min-height: calc(100vh - 80px);
}
.container_upload .m20 {
  margin-bottom: 20px !important;
}
.container_upload .m30 {
  margin-bottom: 30px !important;
}
.container_upload .line30 {
  line-height: 30px;
}
.container_upload h2 {
  font-weight: bold;
  font-size: 16px;
  color: #333;
}
.container_upload .bg {
  background: #edfafa;
  width: 200px;
  height: 46px;
  line-height: 46px;
}
.container_upload .w1380 {
  width: 1380px;
  margin: 0 auto;
  padding-top: 30px;
  padding-bottom: 30px;
}
.container_upload .wapper {
  background: #fff;
  margin-top: 20px;
  color: #666666;
  line-height: 25px;
  position: relative;
}
.container_upload .importation_function_operation {
  min-height: 300px;
  padding: 30px;
}
.container_upload .importation_function_operation h2 {
  margin-bottom: 30px;
}
.container_upload .importation_function_operation .tabInfo {
  display: flex;
  align-items: center;
}
.container_upload .importation_function_operation .tabInfo li {
  width: 70px;
  height: 34px;
  text-align: center;
  background: #f0f7f7;
  line-height: 34px;
  margin-right: 10px;
  cursor: pointer;
}
.container_upload .importation_function_operation .tabInfo .checked {
  color: #fff;
  background: #2d8cf0;
}
.container_upload .importation_function_operation .tabInfo li:last-of-type {
  width: 102px;
}
.container_upload .improtation_list li {
  position: relative;
  padding-left: 20px;
  margin-top: 15px;
}

.container_upload .improtation_list li::after {
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -3px;
  width: 6px;
  height: 6px;
  content: "";
  background: #2d8cf0;
}
.container_upload .upload_top {
  background: #fff;
  height: 360px;
  position: relative;
  padding: 30px;
}
.container_upload .upload_top .upload_bg {
  width: 100%;
  background: linear-gradient(0deg, #ffffff 0%, #e1f5f5 100%), #ffffff;
  height: 160px;
  position: absolute;
  top: 0;
  left: 0;
}
.container_upload .upload_top .upload-demo {
  padding-top: 30px;
  text-align: center;
}
.container_upload .upload_top .upload-demo .el-upload__tip {
  color: #999999;
}
.container_upload .upload_top .upload-demo .el-upload__tip i {
  margin-right: 5px;
}

.container_upload .abstract_info {
  min-height: 200px;
  margin-bottom: 30px;
}
.container_upload .abstract_info .bg {
  padding-left: 30px;
  margin-bottom: 20px;
}
.container_upload .abstract_info .abstract_info_div {
  padding: 0px 30px;
}
.container_upload .abstract_info .abstract_info_div h2 {
  margin-bottom: 20px;
}

.container_upload .introduction_info {
  min-height: 300px;
  padding-bottom: 30px;
}
.container_upload .introduction_info .bg {
  padding-left: 30px;
  margin-bottom: 20px;
}
.container_upload .introduction_info .introduction_info_div {
  padding: 0px 30px;
}
.container_upload .introduction_info .introduction_info_div h2 {
  margin-bottom: 20px;
}

.container_upload .bottom {
  font-size: 12px;
  text-align: center;
  line-height: 25px;
  height: 80px;
  background: #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666666;
}
.container_upload .pre-line {
  white-space: pre-line;
  text-align: left;
}
.container_upload .overflow_hidden {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 30;
  overflow: hidden;
}
.container_upload .d3-wapper {
  margin-top: 20px;
  position: relative;
}
.container_upload .showMsg {
  position: absolute;
  z-index: 2999;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
